/**
 * created by li si yi
 * 部门筛选组件
 */
import React, {Component} from 'react';
import {Button, Input, Select} from "antd";
import BaseComponent from "../../../../base/BaseComponent";
import moment from "moment";
import '../publishStatistics.css'

const {Option} = Select;

class DeptSelect extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            deptList: [],// 部门数据
            deptIds: [window.currentUser.deptIds.toString()] || [],// 可能是字符串拼接
        }
    }

    componentDidMount() {
    }

    componentWillReceiveProps(nextProps, nextContext) {
        // console.log(nextProps, nextContext);
        if (nextProps.resetDept !== this.props.resetDept) {
            this.state.deptIds = nextProps.resetDept;
            this.setState({})
        }
    }

    render() {
        this.state.deptList = JSON.parse(JSON.stringify(this.props?.deptList));
        let {size, disabled, id, placeholder, style, value,maxTagCount} = this.props;
        let valueTemp = [];
        if (Array.isArray(this.state.deptList)&&this.state.deptList.length) {
            valueTemp = value && value !== "" ? value : this.state.deptIds === "" || value === '' ? undefined : this.state.deptIds;
        }
        return (
            <>
                <Select
                    className={'select_dept select-without-tag'}
                    mode="multiple"
                    style={style ? style : {width: '240px', marginRight: 20}}
                    placeholder={placeholder ? placeholder : "请选择所属单位"}
                    value={valueTemp}
                    onChange={(value, e) => {
                        this.handleChangeDept(value, e)
                    }}
                    optionFilterProp={"children"}
                    size={size}
                    disabled={disabled}
                    id={id}
                    maxTagCount={maxTagCount}
                >
                    {this.state.deptList && this.state.deptList.map((item, index) => {
                        return (
                            <Option key={item.id} value={item.id}>{item.name}</Option>
                        )
                    })}
                </Select>
                <style>
                    {
                        `.select_dept .ant-select-selection--multiple .ant-select-selection__choice__content {max-width:80px}`
                    }
                </style>
            </>

        );
    };

    // 部门改变
    handleChangeDept = (value, e) => {
        this.state.deptIds = value;
        this.props.checkDept && this.props.checkDept(value);// 传出去的数据
        this.setState({})
    };
}

export default DeptSelect;